import React from 'react';
import { HolidayVillageOutlined, MonetizationOnRounded, SettingsApplications, ShareOutlined } from '@mui/icons-material';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import WebhookOutLinedIcon from '@mui/icons-material/WebhookOutlined';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import RouteOutlined from '@mui/icons-material/RouteOutlined';
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import RuleFolderOutlinedIcon from '@mui/icons-material/RuleFolderOutlined';

export const menu = [
  {
    text: 'Dashboard',
    isActive: false,
    icon: <GridViewOutlinedIcon />,
    to: '/',
    routePrefixMatch: true,
    validPathName: '/dashboard',
  },
  {
    text: 'BIN Management',
    isActive: true,
    icon: <CreditCardIcon />,
    to: '/bin',
    validPathName: '/bin',
    children: [
      {
        text: 'BIN Viewer',
        isActive: false,
        icon: <ManageSearchOutlinedIcon />,
        to: '/bin/viewer',
        routePrefixMatch: true,
        validPathName: '/bin/viewer',
      },
      {
        text: 'BIN Overrides',
        isActive: false,
        icon: <AddCardOutlinedIcon />,
        to: '/bin/overrides',
        validPathName: '/bin/overrides',
      },
      {
        text: 'BIN Mapping Configuration',
        isActive: false,
        icon: <AccountTreeOutlinedIcon />,
        to: '/bin/mapping',
        validPathName: '/bin/mapping',
      },
    ],
  },
  {
    text: 'Fee Rules Management',
    isActive: false,
    icon: <MonetizationOnRounded />,
    to: '/fee',
    validPathName: '/fee',
    children: [
      {
        text: 'Fee - BIN Bridge',
        isActive: false,
        icon: <FactCheckOutlinedIcon />,
        to: '/fee/bridge',
        validPathName: '/fee/bridge',
      },
    ],
  },
  {
    text: 'Routing Rules Management',
    isActive: false,
    icon: <CollectionsBookmarkIcon />,
    to: '/routing',
    validPathName: '/routing',
    children: [
      {
        text: 'Routing Profiles',
        isActive: false,
        icon: <ContactsOutlinedIcon />,
        to: '/routing/profiles',
        validPathName: '/routing/profiles',
      },
      {
        text: 'Maintenance Override Requests',
        isActive: false,
        icon: <PublishedWithChangesOutlinedIcon />,
        to: '/routing/MaintenanceOverridesRequests',
        validPathName: '/routing/MaintenanceOverridesRequests',
      },
    ],
  },
  {
    text: 'Reporting & Analytics',
    isActive: false,
    icon: <AnalyticsIcon />,
    to: '/reports',
    validPathName: '/reports',
    children: [
      {
        text: 'Merchant Reports',
        isActive: false,
        isSubHeader: true,
        to: '/reports',
        validPathName: '/reports',
      },
      {
        text: 'Cost Savings by MCC',
        isActive: false,
        icon: <PriceCheckIcon />,
        to: '/reports/costsavingsbymccinternalmerchant',
        validPathName: '/reports/costsavingsbymccinternalmerchant',
      },
      {
        text: 'Routing Summary',
        isActive: false,
        icon: <RouteOutlined />,
        to: '/reports/RoutingSummaryInternal',
        validPathName: '/reports/RoutingSummaryInternal',
      },
      {
        text: 'Operational Reports',
        isActive: false,
        isSubHeader: true,
        to: '/reports',
        validPathName: '/reports',
      },
      {
        text: 'Decision Discrepancy',
        isActive: false,
        icon: <CallSplitOutlinedIcon />,
        to: '/reports/DecisionDiscrepancyInternal',
        validPathName: '/reports/DecisionDiscrepancyInternal',
      },
    ],
  },
  {
    text: 'RTR Configuration',
    isActive: false,
    icon: <SettingsApplications />,
    to: '/rtrconfig',
    validPathName: '/rtrconfig',
    children: [
      {
        text: 'Endpoint Profiles',
        isActive: false,
        icon: <ShareOutlined />,
        to: '/rtrconfig/EndpointProfiles',
        validPathName: '/rtrconfig/EndpointProfiles',
      },
      {
        text: 'Front End Profiles',
        isActive: false,
        icon: <HolidayVillageOutlined />,
        to: '/rtrconfig/FrontendProfiles',
        validPathName: '/rtrconfig/FrontendProfiles',
      },
      {
        text: 'Network Configuration',
        isActive: false,
        icon: <WebhookOutLinedIcon />,
        to: '/rtrconfig/NetworkConfiguration',
        validPathName: '/rtrconfig/NetworkConfiguration',
      },
      {
        text: 'PINless Card Present Rules',
        isActive: false,
        icon: <RuleFolderOutlinedIcon />,
        to: '/rtrconfig/PINlessCPrules',
        validPathName: '/rtrconfig/PINlessCPrules',
      },
    ],
  },
  {
    text: 'Data Views',
    isActive: false,
    icon: <LibraryBooksIcon />,
    to: '/dataviews',
    validPathName: '/dataviews',
  },
];
